// src/core/api/BaseApiService.js
import http from "./HttpServices";
import { getAccessToken } from "@/helper";
import { empty } from "@/functions/var/empty";

/** ─────────────────────────────
 * set default headers
 * ───────────────────────────── */
const setDefaultHeaders = () => {
    const token = getAccessToken();
    const businessId = domain_obj?.business_id ?? null;

    // ست کردن Authorization فقط در صورت وجود
    if (token) {
        http.axios.defaults.headers.common["Authorization"] = token;
    } else {
        delete http.axios.defaults.headers.common["Authorization"];
    }

    // ست کردن business_id فقط در صورت وجود
    if (!empty(businessId)) {
        http.axios.defaults.headers.common["business_id"] = businessId;
    } else {
        delete http.axios.defaults.headers.common["business_id"];
    }
};

/** ─────────────────────────────
 * Normalize data (string → JSON)
 * ───────────────────────────── */
const normalizeData = (data) => {
    if (!data) return {};
    if (typeof data === "string") {
        try {
            return JSON.parse(data);
        } catch {
            return {};
        }
    }
    if (typeof data === "object") {
        return { ...data };
    }
    return {};
};

/** ─────────────────────────────
 * (fa/en)
 * ───────────────────────────── */
const getDefaultLang = () => {
    const lang = 'fa';//navigator?.language?.startsWith("fa") ? "fa" : "en";
    return lang;
};

/** ─────────────────────────────
 * POST Request
 * ───────────────────────────── */
export const basePostData = async (endPoint, data) => {
    setDefaultHeaders();

    const businessId = domain_obj?.business_id ?? null;
    const jsonData = normalizeData(data);

    // تنظیم مقادیر پیش‌فرض
    if (!("lang" in jsonData)) {
        jsonData.lang = getDefaultLang();
    }
    if (!("cb_id" in jsonData) && !empty(businessId)) {
        jsonData.cb_id = businessId;
    }

    return http.post(endPoint, jsonData);
};

/** ─────────────────────────────
 * GET Request
 * ───────────────────────────── */
export const baseGetData = async (endPoint, params = {}) => {
    setDefaultHeaders();

    const businessId = domain_obj?.business_id ?? null;
    const mergedParams = {
        lang: getDefaultLang(),
        cb_id: businessId,
        ...params,
    };

    return http.get(endPoint, { params: mergedParams });
};

/** ─────────────────────────────
 * PUT Request
 * ───────────────────────────── */
export const basePutData = async (endPoint, data) => {
    setDefaultHeaders();
    const jsonData = normalizeData(data);
    return http.put(endPoint, jsonData);
};

/** ─────────────────────────────
 * DELETE Request
 * ───────────────────────────── */
export const baseDeleteData = async (endPoint, data) => {
    setDefaultHeaders();
    const jsonData = data ? normalizeData(data) : {};
    return http.delete(endPoint, { data: jsonData });
};

/** ─────────────────────────────
 * PATCH Request
 * ───────────────────────────── */
export const basePatchData = async (endPoint, data) => {
    setDefaultHeaders();
    const jsonData = normalizeData(data);
    return http.patch(endPoint, jsonData);
};

/** ─────────────────────────────
 * upload files,images with multipart-form-data
 * ───────────────────────────── */
export const baseUploadFile = async (endPoint, file, extraData = {}) => {
    setDefaultHeaders();
    const formData = new FormData();

    formData.append("file", file);
    Object.entries(extraData).forEach(([key, value]) => {
        formData.append(key, value);
    });

    return http.post(endPoint, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

/** ─────────────────────────────
 * فایل دانلود
 * ───────────────────────────── */
export const baseDownloadFile = async (endPoint, params = {}) => {
    setDefaultHeaders();

    return http.get(endPoint, {
        params,
        responseType: "blob",
    });
};
